module.exports = __webpack_public_path__ + "static/media/pk.c02a9989.svg";